module.exports = __webpack_public_path__ + "img/empty.836ef512.png";